<template>
  <div>
    <filter-slot
      :filter="filters"
      :filterPrincipal="filterPrincipal"
      :paginate="paginate"
      @reload="myProvider"
      :showPagination="false"
      :buttons-col-config="{ sm: 12, md: 12, lg: 12 }"
      buttons-wrapper-class="d-flex justify-content-end align-items-center"
    >
      <template #buttons-filter>
        <b-row class="my-1 w-100 mx-0 pl-1">
          <b-col
            cols="12"
            class="d-flex justify-content-start align-items-center mx-0 px-0 gap-x-2"
          >
            <b-button
              v-if="totalSeleccionados > 0"
              class="mr-1"
              variant="outline-success"
              @click="aprobarCts"
            >
              <feather-icon icon="CheckCircleIcon" class="mr-1" />
              APROBAR
            </b-button>
            <!-- <b-button v-if="items.length > 0" class="mr-1" variant="outline-info" @click="generarCts">
              <feather-icon icon="RefreshCcwIcon" class="mr-1" />
              RECALCULAR
            </b-button> -->
            <!-- <b-button
          class="mr-1"
          variant="info"
          v-b-tooltip.hover.top="$t('Download Excel')"
          @click="exportToExcel"
        >
          <feather-icon icon="FileTextIcon" /> Excel
        </b-button> -->
            <!-- <b-button
          variant="primary"
          v-b-tooltip.hover.top="'Reporte de Vacaciones'"
          @click="showReporteVacacionesModal = true"
        >
          <feather-icon icon="CalendarIcon" /> Reporte
        </b-button> -->

            <b-form-select
              v-if="anioOptions.length > 0"
              v-model="anioSeleccionado"
              :options="anioOptions"
              style="max-width: 200px"
              @change="handleAnioChange"
            >
            </b-form-select>

            <b-form-select
              v-model="periodoSeleccionadoId"
              :options="periodos"
              value-field="id"
              text-field="anio_periodo"
              style="max-width: 200px"
            >
              <template #first>
                <b-form-select-option :value="null" disabled>
                  Seleccione ...
                </b-form-select-option>
              </template>
            </b-form-select>

            <b-form-select v-model="categoriaSeleccionada" :options="categoriaOptions"
              style="max-width: 200px" @change="handleCategoriaChange">
              <template #first>
                <b-form-select-option :value="null">
                  Todas las categorías
                </b-form-select-option>
              </template>
            </b-form-select>

            <b-form-select v-model="tipoUtSeleccionado" :options="tipoUtOptions"
              style="max-width: 200px" @change="handleTipoUtChange">
              <template #first>
                <b-form-select-option :value="null">
                  Todos los tipos UT
                </b-form-select-option>
              </template>
            </b-form-select>
          </b-col>
        </b-row>
      </template>

      <template #table>
        <b-table-simple
          ref="table-bono"
          small
          table-class="text-nowrap"
          sticky-header="60vh"
          class="font-small-3 table-sticky"
          hover
        >
          <b-thead>
            <b-tr>
              <!-- <b-th class="sticky-top">
                <b-form-checkbox v-model="allSelected" :indeterminate="items.some((item) => item.selected) && !allSelected
                  " @change="handleSelectAll" />
              </b-th> -->
              <b-th sticky-column class="sticky-col" style="min-width: 220px; position: sticky !important; left: 0px !important; top: 0px !important; z-index: 50 !important; text-align: left !important;">Trabajador</b-th>
              <b-th class="sticky-top">Nro. Documento</b-th>
              <b-th class="sticky-top">Estado</b-th>
              <b-th class="sticky-top">Periodo</b-th>

              <b-th class="sticky-top">CATEGORIA BONO</b-th>
              <b-th class="sticky-top">TIPO UT</b-th>

              <!-- ============================================== -->
              <!-- BLOQUE: NÚMERO DE VIAJES / CANTIDADES (TRAMOS Y CONCEPTOS) -->
              <!-- ============================================== -->
              <b-th class="sticky-top">
                <div
                  class="d-flex flex-column justify-content-center align-items-center"
                >
                  <span># CAMBIOS</span>
                  <span>CONDUCTOR</span>
                </div>
              </b-th>
              <b-th class="sticky-top">
                <div
                  class="d-flex flex-column justify-content-center align-items-center"
                >
                  <span>#</span>
                  <span>RETORNOS</span>
                </div>
              </b-th>
              <b-th class="sticky-top">
                <div
                  class="d-flex flex-column justify-content-center align-items-center"
                >
                  <span>#</span>
                  <span>DEVOLUCIONES</span>
                </div>
              </b-th>
              <b-th class="sticky-top">
                <div
                  class="d-flex flex-column justify-content-center align-items-center"
                >
                  <span># BONOS</span>
                  <span>F1</span>
                </div>
              </b-th>

              <b-th class="sticky-top">
                <div
                  class="d-flex flex-column justify-content-center align-items-center"
                >
                  <span># VIAJES</span>
                  <span>(0-100KM)</span>
                </div>
              </b-th>

              <b-th class="sticky-top">
                <div
                  class="d-flex flex-column justify-content-center align-items-center"
                >
                  <span># VIAJES</span>
                  <span>(100-250KM)</span>
                </div>
              </b-th>

              <b-th class="sticky-top">
                <div
                  class="d-flex flex-column justify-content-center align-items-center"
                >
                  <span># VIAJES</span>
                  <span>(250-980KM)</span>
                </div>
              </b-th>

              <b-th class="sticky-top">
                <div
                  class="d-flex flex-column justify-content-center align-items-center"
                >
                  <span># VIAJES</span>
                  <span>(980-1400KM)</span>
                </div>
              </b-th>

              <b-th class="sticky-top">
                <div
                  class="d-flex flex-column justify-content-center align-items-center"
                >
                  <span># VIAJES</span>
                  <span>(1400-1800KM)</span>
                </div>
              </b-th>

              <!-- TOTAL SERVICIOS (CANTIDAD TOTAL) -->
              <b-th class="sticky-top col-destacada-guinda">
                <div
                  class="d-flex flex-column justify-content-center align-items-center font-weight-bolder"
                >
                  <span>TOTAL</span>
                  <span>SERVICIOS</span>
                </div>
              </b-th>

              <!-- ============================================== -->
              <!-- BLOQUE: IMPORTES / MONTOS (TRAMOS Y CONCEPTOS) -->
              <!-- ============================================== -->
              <b-th class="sticky-top">
                <div
                  class="d-flex flex-column justify-content-center align-items-center"
                >
                  <span>MTO. CAMBIOS</span>
                  <span>CONDUCTOR</span>
                </div>
              </b-th>

              <b-th class="sticky-top">
                <div
                  class="d-flex flex-column justify-content-center align-items-center"
                >
                  <span>MTO.</span>
                  <span>RETORNOS</span>
                </div>
              </b-th>

              <b-th class="sticky-top">
                <div
                  class="d-flex flex-column justify-content-center align-items-center"
                >
                  <span>MTO.</span>
                  <span>DEVOLUCIONES</span>
                </div>
              </b-th>

              <b-th class="sticky-top">
                <div
                  class="d-flex flex-column justify-content-center align-items-center"
                >
                  <span>MTO.</span>
                  <span>BONOS F1</span>
                </div>
              </b-th>

              <b-th class="sticky-top">
                <div
                  class="d-flex flex-column justify-content-center align-items-center"
                >
                  <span>MTO. VIAJES</span>
                  <span>(0-100KM)</span>
                </div>
              </b-th>

              <b-th class="sticky-top">
                <div
                  class="d-flex flex-column justify-content-center align-items-center"
                >
                  <span>MTO. VIAJES</span>
                  <span>(100-250KM)</span>
                </div>
              </b-th>

              <b-th class="sticky-top">
                <div
                  class="d-flex flex-column justify-content-center align-items-center"
                >
                  <span>MTO. VIAJES</span>
                  <span>(250-980KM)</span>
                </div>
              </b-th>

              <b-th class="sticky-top">
                <div
                  class="d-flex flex-column justify-content-center align-items-center"
                >
                  <span>MTO. VIAJES</span>
                  <span>(980-1400KM)</span>
                </div>
              </b-th>

              <b-th class="sticky-top">
                <div
                  class="d-flex flex-column justify-content-center align-items-center"
                >
                  <span>MTO. VIAJES</span>
                  <span>(1400-1800KM)</span>
                </div>
              </b-th>

              <b-th class="sticky-top">
                <div class="d-flex flex-column justify-content-center align-items-center">
                  <span>TOTAL</span>
                  <span>ADICIONAL</span>
                </div>
              </b-th>

              <b-th class="sticky-top">
                <div
                  class="d-flex flex-column justify-content-center align-items-center"
                >
                  <span>BONO</span>
                  <span>TOTAL BRUTO</span>
                </div>
              </b-th>

              <b-th class="sticky-top">DESCUENTO</b-th>

              <b-th class="sticky-top col-destacada-guinda">
                <div
                  class="d-flex flex-column justify-content-center align-items-center font-weight-bolder"
                >
                  <span>BONO</span>
                  <span>TOTAL NETO</span>
                </div>
              </b-th>

              <b-th class="sticky-top">OBSERVACIONES</b-th>

              <b-th class="sticky-top">ACCION</b-th>
            </b-tr>
          </b-thead>

          <b-tbody v-if="items.length">
            <b-tr v-for="(item, idx) in items" :key="idx">
              <!-- <b-td class="text-center">
                <b-form-checkbox v-if="item.estado === 'GENERADO'" v-model="item.selected" :value="true"
                  :unchecked-value="false" />
              </b-td> -->

              <!-- Trabajador -->
              <b-td sticky-column class="sticky-col" style="min-width: 220px; position: sticky !important; left: 0px !important; z-index: 2 !important; text-align: left !important;">
                <router-link
                  v-if="item.employee_id != null"
                  target="_blank"
                  :class="[textLink]"
                  :to="{
                    name: 'rrhh-employees-information',
                    params: { id: item.employee_id },
                  }"
                >
                  {{ item.empleado | capitalize }}
                </router-link>
                <span v-else class="text-danger">{{
                  item.nombre_completo
                }}</span>
              </b-td>

              <b-td class="text-center">
                <span style="opacity: 0.7" class="text-primary">
                  {{ item.numero_documento | capitalize }}
                </span>
              </b-td>

              <!-- Estado -->
              <b-td class="text-center">
                <b-badge :variant="resolveStatus(item.estado)" class="ml-1">
                  {{ item.estado }}
                </b-badge>
              </b-td>

              <b-td class="text-center">
                <span>{{ item.periodo }}</span>
              </b-td>

              <b-td class="text-center">
                <span>{{ item.bono_categoria }}</span>
              </b-td>

              <b-td class="text-center">
                <span>{{ item.tipo_ut }}</span>
              </b-td>

              <!-- ============================================== -->
              <!-- BLOQUE: NÚMERO DE VIAJES / CANTIDADES (TRAMOS Y CONCEPTOS) -->
              <!-- ============================================== -->
              <!-- 1. # CAMBIOS CONDUCTOR -->
              <b-td class="text-center">
                <div class="d-flex gap-x-3 w-100 justify-content-center">
                  <span class="d-block text-center">{{
                    parseInt(item.cambio_conductor_cantidad)
                  }}</span>
                  <feather-icon
                    v-if="item.COUNT_CC > 0"
                    icon="AlertCircleIcon"
                    class="text-warning"
                    @click="handleIconClick(item, 'ERROR', 'CAMBIO_CONDUCTOR')"
                  />

                  <feather-icon
                    v-if="item.EX_COUNT_CC > 0"
                    icon="AlertCircleIcon"
                    class="text-success"
                    @click="handleIconClick(item, 'EXITO', 'CAMBIO_CONDUCTOR')"
                  />
                </div>
              </b-td>

              <!-- 2. # RETORNOS -->
              <b-td class="text-center">
                <div class="d-flex gap-x-3 w-100 justify-content-center">
                  <span class="d-block text-center">{{
                    parseInt(item.retornos_cantidad)
                  }}</span>
                  <feather-icon
                    v-if="item.COUNT_RE > 0"
                    icon="AlertCircleIcon"
                    class="text-warning"
                    @click="handleIconClick(item, 'ERROR', 'RETORNOS')"
                  />

                  <feather-icon
                    v-if="item.EX_COUNT_RE > 0"
                    icon="AlertCircleIcon"
                    class="text-success"
                    @click="handleIconClick(item, 'EXITO', 'RETORNOS')"
                  />

                  <feather-icon
                    v-if="parseInt(item.retornos_cantidad) > 0"
                    icon="Edit2Icon"
                    class="text-primary cursor-pointer"
                    v-b-tooltip.hover
                    title="Ver / ajustar retornos"
                    @click="abrirRetornosDetalle(item)"
                  />
                </div>
              </b-td>

              <!-- 3. # DEVOLUCIONES -->
              <b-td class="text-center">
                <div class="d-flex gap-x-3 w-100 justify-content-center">
                  <span class="d-block text-center">{{
                    parseInt(item.devoluciones_cantidad)
                  }}</span>
                  <feather-icon
                    v-if="item.COUNT_DEV > 0"
                    icon="AlertCircleIcon"
                    class="text-warning"
                    @click="handleIconClick(item, 'ERROR', 'DEVOLUCION')"
                  />

                  <feather-icon
                    v-if="item.EX_COUNT_DEV > 0"
                    icon="AlertCircleIcon"
                    class="text-success"
                    @click="handleIconClick(item, 'EXITO', 'DEVOLUCION')"
                  />
                </div>
              </b-td>

              <!-- 4. # BONOS F1 -->
              <b-td class="text-center">
                <div class="d-flex gap-x-3 w-100 justify-content-center">
                  <span class="d-block text-center">{{
                    parseInt(item.bono_f1_cantidad)
                  }}</span>
                  <feather-icon
                    v-if="item.COUNT_F1 > 0"
                    icon="AlertCircleIcon"
                    class="text-warning"
                    @click="handleIconClick(item, 'ERROR', 'F1')"
                  />

                  <feather-icon
                    v-if="item.EX_COUNT_F1 > 0"
                    icon="AlertCircleIcon"
                    class="text-success"
                    @click="handleIconClick(item, 'EXITO', 'F1')"
                  />
                </div>
              </b-td>

              <!-- 5. # VIAJES (0-100KM) -->
              <b-td class="text-center">
                <span class="d-block text-center">{{
                  parseInt(item.mas21_tramo_1_cantidad)
                }}</span>
              </b-td>

              <!-- 6. # VIAJES (100-250KM) -->
              <b-td class="text-center">
                <span class="d-block text-center">{{
                  parseInt(item.mas21_tramo_2_cantidad)
                }}</span>
              </b-td>

              <!-- 7. # VIAJES (250-980KM) -->
              <b-td class="text-center">
                <div class="d-flex gap-x-2 w-100 justify-content-center align-items-center">
                  <span class="d-block text-center">{{
                    parseInt(item.mas21_tramo_3_cantidad)
                  }}</span>
                  <feather-icon
                    v-if="parseInt(item.mas21_tramo_3_cantidad) > 0"
                    icon="Edit2Icon"
                    class="text-primary cursor-pointer"
                    v-b-tooltip.hover
                    title="Ver / ajustar viajes (250-980km)"
                    @click="abrirTramo3Detalle(item)"
                  />
                </div>
              </b-td>

              <!-- 8. # VIAJES (980-1400KM) -->
              <b-td class="text-center">
                <span class="d-block text-center">{{
                  parseInt(item.mas21_tramo_4_cantidad)
                }}</span>
              </b-td>

              <!-- 9. # VIAJES (1400-1800KM) -->
              <b-td class="text-center">
                <span class="d-block text-center">{{
                  parseInt(item.mas21_tramo_5_cantidad)
                }}</span>
              </b-td>

              <!-- TOTAL SERVICIOS (CANTIDAD TOTAL) -->
              <b-td class="text-center font-weight-bolder col-destacada-guinda">
                <div class="d-flex gap-x-2 w-100 justify-content-center align-items-center">
                  <span class="d-block text-center font-weight-bolder">
                    {{ calcularTotalServicios(item) }}
                  </span>
                  <feather-icon
                    v-if="
                      item.COUNT_21 +
                        item.COUNT_A +
                        item.COUNT_B +
                        item.COUNT_C >
                      0
                    "
                    @click="handleIconClick(item, 'ERROR', '21+')"
                    icon="AlertCircleIcon"
                    class="text-warning cursor-pointer"
                    v-b-tooltip.hover
                    title="Ver observaciones de viajes"
                  />

                  <feather-icon
                    v-if="
                      item.EX_COUNT_21 +
                        item.EX_COUNT_A +
                        item.EX_COUNT_B +
                        item.EX_COUNT_C >
                      0
                    "
                    @click="handleIconClick(item, 'EXITO', '21+')"
                    icon="AlertCircleIcon"
                    class="text-success cursor-pointer"
                    v-b-tooltip.hover
                    title="Ver detalle de viajes procesados"
                  />
                </div>
              </b-td>

              <!-- ============================================== -->
              <!-- BLOQUE: IMPORTES / MONTOS (TRAMOS Y CONCEPTOS) -->
              <!-- ============================================== -->
              <!-- 1. MTO. CAMBIOS CONDUCTOR -->
              <b-td class="text-right">
                <span class="d-block text-right text-primary"
                  >S/ {{ item.cambio_conductor_monto | currency }}</span
                >
              </b-td>

              <!-- 2. MTO. RETORNOS -->
              <b-td class="text-right">
                <span class="d-block text-right text-primary"
                  >S/ {{ item.retornos_monto | currency }}</span
                >
              </b-td>

              <!-- 3. MTO. DEVOLUCIONES -->
              <b-td class="text-right">
                <span class="d-block text-right text-primary"
                  >S/ {{ item.devoluciones_monto | currency }}</span
                >
              </b-td>

              <!-- 4. MTO. BONOS F1 -->
              <b-td class="text-right">
                <span class="d-block text-right text-primary"
                  >S/ {{ item.bono_f1_monto | currency }}</span
                >
              </b-td>

              <!-- 5. MTO. VIAJES (0-100KM) -->
              <b-td class="text-right">
                <span class="d-block text-right text-primary"
                  >S/ {{ item.mas21_tramo_1_monto | currency }}</span
                >
              </b-td>

              <!-- 6. MTO. VIAJES (100-250KM) -->
              <b-td class="text-right">
                <span class="d-block text-right text-primary"
                  >S/ {{ item.mas21_tramo_2_monto | currency }}</span
                >
              </b-td>

              <!-- 7. MTO. VIAJES (250-980KM) -->
              <b-td class="text-right">
                <span class="d-block text-right text-primary"
                  >S/ {{ item.mas21_tramo_3_monto | currency }}</span
                >
              </b-td>

              <!-- 8. MTO. VIAJES (980-1400KM) -->
              <b-td class="text-right">
                <span class="d-block text-right text-primary"
                  >S/ {{ item.mas21_tramo_4_monto | currency }}</span
                >
              </b-td>

              <!-- 9. MTO. VIAJES (1400-1800KM) -->
              <b-td class="text-right">
                <span class="d-block text-right text-primary"
                  >S/ {{ item.mas21_tramo_5_monto | currency }}</span
                >
              </b-td>

              <!-- ADICIONAL -->
              <b-td class="text-right">
                <span class="d-block text-right text-primary">S/ {{ item.adicional_bono | currency }}</span>
              </b-td>

              <!-- REMUN.BASE CTS -->
              <b-td class="text-right">
                <span class="d-block text-right text-primary"
                  >S/ {{ item.total_bono_bruto | currency }}</span
                >
              </b-td>

              <!-- REMUN.BASE CTS -->
              <b-td class="text-right">
                <span class="d-block text-right text-primary">S/ 0</span>
              </b-td>

              <!-- BONO TOTAL NETO -->
              <b-td class="text-right font-weight-bolder col-destacada-guinda">
                <span class="d-block text-right font-weight-bolder"
                  >S/ {{ item.total_bono_neto | currency }}</span
                >
              </b-td>

              <b-td>
                <p>{{ item.observaciones }}</p>
              </b-td>

              <b-td>
                <div
                  class="d-flex justify-content-center align-items-center gap-x-2"
                >
                  <feather-icon
                    v-if="item.total_bono_neto > 0"
                    @click="aprobarBono(item)"
                    icon="CheckCircleIcon"
                    class="text-primary cursor-pointer"
                    v-b-tooltip.hover.top="item.estado === 'APROBADO' ? 'Ver detalle (Aprobado)' : 'Aprobar bono'"
                  />
                  <feather-icon
                    v-if="item.estado !== 'PROCESANDO'"
                    @click="recalcularBono(item)"
                    icon="RefreshCcwIcon"
                    class="text-warning cursor-pointer"
                    v-b-tooltip.hover.top="'Recalcular bono'"
                  />
                  <feather-icon
                    @click="abrirResumenBono(item)"
                    icon="EyeIcon"
                    class="text-primary cursor-pointer"
                    v-b-tooltip.hover.top="'Ver resumen del bono'"
                  />
                  <!-- <feather-icon @click="handleDelete(item)" icon="TrashIcon" class="text-danger" /> -->
                </div>
              </b-td>
            </b-tr>
          </b-tbody>

          <!-- <b-tfoot>
            <b-tr class="sticky-data" :class="isDarkSkin ? 'bg-dark text-white' : 'bg-white text-dark'">
              <b-td v-for="(col, index) in totalColumns" :key="index" class="text-center">
                <template v-if="index === 5">
                  S/. {{ sumaSueldoBasico | currency }}
                </template>
<template v-if="index === 6">
                  S/. {{ sumaAsignacionFamiliar | currency }}
                </template>
<template v-if="index === 7">
                  S/. {{ sumaPromedioHorasExtras | currency }}
                </template>
<template v-if="index === 8">
                  S/. {{ sumaPromedioBonoDesempeno | currency }}
                </template>
<template v-if="index === 9">
                  S/. {{ sumaPromedioGratificacion | currency }}
                </template>
<template v-if="index === 10">
                  S/. {{ sumaRemuneracionBaseCTS | currency }}
                </template>
<template v-if="index === 11">
                  S/. {{ sumaRemuneracionBaseCTSMYPE | currency }}
                </template>
<template v-if="index === 12">
                  S/. {{ sumaCTSCalculado | currency }}
                </template>
<template v-if="index === 13">
                  S/. {{ sumaInteresCTS | currency }}
                </template>
<template v-if="index === 14">
                  S/. {{ sumaCTSDepositado | currency }}
                </template>
</b-td>
</b-tr>
</b-tfoot> -->
        </b-table-simple>
      </template>
    </filter-slot>

    <!-- <ModalGenerarCts
      v-if="showModal"
      :show="showModal"
      @close="showModal = false"
      @generated="handleGenerated"
    /> -->

    <BonoErrorMessagesModal
      v-if="showModalErrors"
      :modalData="errorDataModal.data"
      :categoria="errorDataModal.categoria"
      :tipo="errorDataModal.tipo"
      @close="showModalErrors = false"
    />

    <RetornosDetalleModal
      v-if="showRetornosDetalleModal"
      :modalData="retornosDetalleData"
      @close="showRetornosDetalleModal = false"
      @refresh="refreshTable"
    />

    <Tramo3DetalleModal
      v-if="showTramo3DetalleModal"
      :modalData="tramo3DetalleData"
      @close="showTramo3DetalleModal = false"
      @refresh="refreshTable"
    />

    <ModalGenerarBonos
      v-if="showModal"
      :show="showModal"
      @close="showModal = false"
      @generated="handleGenerated"
    />

    <AprobarBonoModal
      v-if="aprobarBonoShow"
      :show="aprobarBonoShow"
      :modalData="aprobarBonoData"
      @close="handleCloseAprobarBonoModal"
      @approvePayroll="handleApprovePayroll"
    />

    <PlanillaProcesamientoModal
      v-if="showPlanillaProcesamientoModal"
      :modalData="batchData"
      @close="handleClosePlanillaProcesamientoModal"
    />

    <BonoResumenConductorModal
      v-if="showModalResumen"
      :modalData="resumenModalData"
      @close="showModalResumen = false"
    />
  </div>
</template>

<script>
import { mapGetters } from "vuex";

// import Filters from "@/views/rrhh/views/payroll/components/vacaciones/data/filters.js";
import FilterSlot from "@/views/commons/filter-slot/FilterSlot.vue";
import CtsService from "@/views/rrhh/views/payroll/components/cts/service/cts.service.js";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import ModalGenerarBonos from "@/views/rrhh/views/payroll/components/bonos/components/ModalGenerarBonos.vue";
import BonoService from "@/views/rrhh/views/payroll/components/bonos/service/bono.service.js";
import BonoErrorMessagesModal from "@/views/rrhh/views/payroll/components/bonos/components/BonoErrorMessagesModal.vue";
import AprobarBonoModal from "@/views/rrhh/views/payroll/components/bonos/components/AprobarBonoModal.vue";
import RetornosDetalleModal from "@/views/rrhh/views/payroll/components/bonos/components/RetornosDetalleModal.vue";
import Tramo3DetalleModal from "@/views/rrhh/views/payroll/components/bonos/components/Tramo3DetalleModal.vue";
import moment from "moment-timezone";
import PlanillaProcesamientoModal from "@/views/rrhh/views/payroll/components/administrative-payroll/PlanillaProcesamientoModal.vue";
import BonoResumenConductorModal from "@/views/rrhh/views/payroll/components/bonos/components/BonoResumenConductorModal.vue";

export default {
  components: {
    FilterSlot,
    ModalGenerarBonos,
    BonoErrorMessagesModal,
    AprobarBonoModal,
    RetornosDetalleModal,
    Tramo3DetalleModal,
    PlanillaProcesamientoModal,
    BonoResumenConductorModal,
  },
  data() {
    return {
      filters: [],
      isBusy: false,
      sortBy: "",
      sortDesc: true,
      filterPrincipal: {
        type: "input",
        inputType: "text",
        placeholder: "Search...",
        model: "",
      },
      paginate: {
        from: 0,
        to: 0,
        of: 0,
        perPage: 100,
        currentPage: 1,
      },
      showModal: false,
      operacion: "cts",
      items: [],
      ultimosMeses: [],
      periodos: [],
      anioOptions: [],
      anioSeleccionado: null,
      periodoSeleccionadoId: null,
      periodoSeleccionado: null,
      allSelected: false,
      categoriaSeleccionada: null,
      categoriaOptions: [],
      tipoUtSeleccionado: null,
      tipoUtOptions: [],
      totalColumns: Array(17).fill(null), // genera un array con 17 elementos nulos
      showModalErrors: false,
      errorDataModal: { data: null, categoria: null, tipo: null },
      showRetornosDetalleModal: false,
      retornosDetalleData: null,
      showTramo3DetalleModal: false,
      tramo3DetalleData: null,
      aprobarBonoData: null,
      aprobarBonoShow: false,

      showModalResumen: false,
      resumenModalData: null,

      showPlanillaProcesamientoModal: false,
      batchData: {
        id: null,
        name: null,
        status: null,
        message: null,
        progress: 0,
        total_jobs: 0,
        processed_jobs: 0,
        pending_jobs: 0,
        failed_jobs: 0,
        failed_job_details: [],
        created_at: null,
        finished_at: null,
        finished: false,
      },
      progressInterval: null,
    };
  },
  watch: {
    periodoSeleccionadoId(newVal) {
      if (newVal) {
        this.periodoSeleccionado =
          this.periodos.find((p) => p.id == newVal) || null;
        this.categoriaSeleccionada = null;
        this.tipoUtSeleccionado = null;
        this.paginate.currentPage = 1;
        // cargar items del periodo seleccionado
        this.myProvider();
      } else {
        this.periodoSeleccionado = null;
        this.items = [];
        this.categoriaOptions = [];
        this.tipoUtOptions = [];
      }
    },
  },
  computed: {
    ...mapGetters({
      currentUser: "auth/currentUser",
    }),

    totalSeleccionados() {
      return this.items.filter((item) => item.selected).length;
    },
    // Suma Sueldo Basico
    sumaSueldoBasico() {
      return this.items.reduce(
        (acc, item) => acc + (Number(item.sueldo_basico) || 0),
        0,
      );
    },

    // Suma Asignacion Familiar
    sumaAsignacionFamiliar() {
      return this.items.reduce(
        (acc, item) => acc + (Number(item.asignacion_familiar) || 0),
        0,
      );
    },

    // Suma Promedio Horas Extras
    sumaPromedioHorasExtras() {
      return this.items.reduce(
        (acc, item) => acc + (Number(item.promedio_horas_extras) || 0),
        0,
      );
    },

    // Suma Promedio Bono Desempeno
    sumaPromedioBonoDesempeno() {
      return this.items.reduce(
        (acc, item) => acc + (Number(item.promedio_bono_desempeno) || 0),
        0,
      );
    },

    // Suma Promedio Gratificacion
    sumaPromedioGratificacion() {
      return this.items.reduce(
        (acc, item) => acc + (Number(item.promedio_gratificacion) || 0),
        0,
      );
    },

    // Suma Remuneracion Base CTS
    sumaRemuneracionBaseCTS() {
      return this.items.reduce(
        (acc, item) => acc + (Number(item.remuneracion_base_cts) || 0),
        0,
      );
    },

    // Suma Remuneracion Base CTS MYPE
    sumaRemuneracionBaseCTSMYPE() {
      return this.items.reduce(
        (acc, item) => acc + (Number(item.remuneracion_base_cts_mype) || 0),
        0,
      );
    },

    // Suma CTS Calculado
    sumaCTSCalculado() {
      return this.items.reduce(
        (acc, item) => acc + (Number(item.cts_calculado) || 0),
        0,
      );
    },

    // Suma Interes CTS
    sumaInteresCTS() {
      return this.items.reduce(
        (acc, item) => acc + (Number(item.interes_cts) || 0),
        0,
      );
    },

    // Suma CTS Depositado
    sumaCTSDepositado() {
      return this.items.reduce(
        (acc, item) => acc + (Number(item.cts_dep_en) || 0),
        0,
      );
    },
  },
  async mounted() {
    const anioInicio = 2025;
    const anioActual = moment().year();

    this.anioOptions = [];

    for (let anio = anioInicio; anio <= anioActual; anio++) {
      this.anioOptions.push(anio);
    }
    this.anioSeleccionado = anioActual;

    await this.getPeriodos();
  },
  methods: {
    calcularTotalServicios(item) {
      const f1 = parseInt(item.bono_f1_cantidad) || 0;
      const t1 = parseInt(item.mas21_tramo_1_cantidad) || 0;
      const t2 = parseInt(item.mas21_tramo_2_cantidad) || 0;
      const t3 = parseInt(item.mas21_tramo_3_cantidad) || 0;
      const t4 = parseInt(item.mas21_tramo_4_cantidad) || 0;
      const t5 = parseInt(item.mas21_tramo_5_cantidad) || 0;
      return f1 + t1 + t2 + t3 + t4 + t5;
    },
    abrirResumenBono(item) {
      this.resumenModalData = item;
      this.showModalResumen = true;
    },
    async generarPdfBono(item) {
      try {
        this.addPreloader();
        const params = {
          employee_id: item.employee_id,
          bono_periodo_id: item.bono_periodo_id,
        };
        const response = await BonoService.generarPdfBono(params);
        if (response.status == 200) {
          await this.forceFileDownloadPdf(response);
          this.$toast({
            component: ToastificationContent,
            position: "top-right",
            props: {
              title: this.$t("WorkSheet generated sucessfully"),
              icon: "CoffeeIcon",
              variant: "success",
              text: this.$t("WorkSheet generated sucessfully"),
            },
          });
        }
      } catch (error) {
        console.log(error);
      } finally {
        this.removePreloader();
      }
    },
    handleClosePlanillaProcesamientoModal() {
      this.showPlanillaProcesamientoModal = false;
      this.batchData = {
        id: null,
        name: null,
        status: null,
        message: null,
        progress: 0,
        total_jobs: 0,
        processed_jobs: 0,
        pending_jobs: 0,
        failed_jobs: 0,
        failed_job_details: [],
        created_at: null,
        finished_at: null,
        finished: false,
      };
    },
    handleCloseAprobarBonoModal() {
      this.aprobarBonoShow = false;
      this.getBonos();
    },
    async handleApprovePayroll(params) {
      this.aprobarBonoShow = false;

      this.addPreloader();

      try {
        const { data } = await BonoService.aprobarBono({
          simular: false,
          bonos: [params],
        });

        const batchId = data.batch_id;

        this.showPlanillaProcesamientoModal = true;

        this.progressInterval = setInterval(async () => {
          try {
            const statusData = await BonoService.consultarBono(batchId);

            if (statusData.type === "success") {
              this.batchData = statusData.data;

              if (statusData.data.finished) {
                clearInterval(this.progressInterval);
                this.showToastSuccess("Proceso completado correctamente");
                this.refreshTable();
              }
            }
          } catch (error) {
            clearInterval(this.progressInterval);
            this.showToastError("Error consultando la planilla");
            console.error(error);
          }
        }, 2000);
      } catch (error) {
        this.showToastError(error.response?.data);
      } finally {
        this.removePreloader();
      }
    },
    refreshTable() {
      this.myProvider();
    },
    resolveStatus(stado) {
      switch (stado) {
        case "PROCESANDO":
          return "light-default";
        case "OBSERVADO":
          return "light-warning";
        case "FINALIZADO":
          return "light-success";
        case "RECHAZADO":
          return "light-danger";
        case "APROBADO":
          return "light-primary";
        case "ANULADO":
          return "light-danger";
        default:
          return "light-secondary";
      }
    },
    aprobarBono(item) {
      this.aprobarBonoShow = true;
      this.aprobarBonoData = item;
    },
    /**
     * Vuelve a calcular el bono de un solo conductor para el año y mes
     * seleccionados en la cabecera, sin regenerar todo el periodo.
     */
    async recalcularBono(item) {
      if (!this.periodoSeleccionado) {
        this.showToastError("Debe seleccionar un año y un periodo.");
        return;
      }

      const { anio, periodo } = this.periodoSeleccionado;

      const { isConfirmed } = await this.showConfirmSwal(
        `¿Recalcular el bono de ${item.nombre_completo} para ${anio} - ${periodo}?`,
        "Se anulará el cálculo actual y se volverá a procesar. Los descuentos y adicionales registrados se mantienen."
      );

      if (!isConfirmed) return;

      this.addPreloader();

      try {
        const { data } = await BonoService.recalcular({
          anio,
          periodo,
          empleado_id: item.empleado_id,
        });

        this.showToastSuccess(data.message);
        this.refreshTable();
      } catch (error) {
        this.showToastError(
          error.response?.data?.message ?? "No se pudo recalcular el bono."
        );
      } finally {
        this.removePreloader();
      }
    },
    handleSelectAll() {
      this.items.forEach((item) => {
        if (item.estado === "GENERADO") item.selected = this.allSelected;
      });
    },

    handleAnioChange() {
      this.getPeriodos();
    },
    handleCategoriaChange() {
      this.paginate.currentPage = 1;
      this.myProvider();
    },
    handleTipoUtChange() {
      this.paginate.currentPage = 1;
      this.myProvider();
    },
    handleGenerated() {
      this.showModal = false;
      this.getPeriodos();
      this.myProvider();
    },
    openModalGenerarCts(operacion = "bonos") {
      this.showModal = true;
      this.operacion = operacion;
    },
    async myProvider(ctx) {
      if (this.anioSeleccionado == null) {
        this.periodos = [];
        this.periodoSeleccionadoId = null;
        this.periodoSeleccionado = null;
        this.items = [];
        this.paginate = {
          from: 0,
          to: 0,
          of: 0,
          perPage: 10,
          currentPage: 1,
        };
        this.$toast({
          component: ToastificationContent,
          position: "top-right",
          props: {
            title: "Error",
            icon: "XCircleIcon",
            variant: "danger",
            text: "Debe seleccionar un año.",
          },
        });
        return;
      }
      if (this.periodoSeleccionadoId == null) {
        this.items = [];
        this.paginate = {
          from: 0,
          to: 0,
          of: 0,
          perPage: 10,
          currentPage: 1,
        };
        this.$toast({
          component: ToastificationContent,
          position: "top-right",
          props: {
            title: "Error",
            icon: "XCircleIcon",
            variant: "danger",
            text: "Debe seleccionar un periodo.",
          },
        });
        return;
      }

      try {
        this.addPreloader();
        const params = {
          page: this.paginate.currentPage,
          perpage: this.paginate.perPage,
          search_txt: this.filterPrincipal.model,
          periodo_id: this.periodoSeleccionadoId,
          bono_categoria: this.categoriaSeleccionada,
          tipo_ut: this.tipoUtSeleccionado,
        };
        const { data } = await BonoService.index(params);

        let paginacion = data.data;

        if (data.categorias && Array.isArray(data.categorias)) {
          this.categoriaOptions = data.categorias.map((cat) => ({
            value: cat,
            text: cat === "+21" ? "Categoría +21" : `Categoría ${cat}`,
          }));
        }
        if (data.tipos_ut && Array.isArray(data.tipos_ut)) {
          this.tipoUtOptions = data.tipos_ut.map((ut) => ({
            value: ut,
            text: ut,
          }));
        }

        // loop paginacion data and set items selected = false
        for (let i = 0; i < paginacion.data.length; i++) {
          paginacion.data[i].selected = false;
        }

        this.ultimosMeses = data.ultimosMeses;
        this.items = paginacion.data;
        this.paginate.from = paginacion.from;
        this.paginate.to = paginacion.to;
        this.paginate.of = paginacion.total;
        this.paginate.perPage = paginacion.per_page;
        this.paginate.currentPage = paginacion.current_page;
        // return data.data || [];
      } catch (error) {
        console.log(error);
      } finally {
        this.removePreloader();
      }
    },

    // async getPeriodos() {
    //   try {
    //     const { data } = await CtsService.getPeriodos();
    //     if (data.length > 0) {
    //       this.periodoSeleccionadoId = data[0].id;
    //     }
    //     this.periodos = data || [];
    //   } catch (error) {
    //     console.log(error);
    //     return [];
    //   }
    // },
    async getPeriodos() {
      if (this.anioSeleccionado == null) {
        this.periodos = [];
        this.periodoSeleccionadoId = null;
        this.periodoSeleccionado = null;
        return;
      }

      try {
        const { data } = await BonoService.getPeriodos({
          anio: this.anioSeleccionado,
        });
        this.periodos = data || [];
        if (this.periodos.length > 0) {
          this.periodoSeleccionadoId = this.periodos[0].id;
        } else {
          this.periodoSeleccionadoId = null;
          this.periodoSeleccionado = null;
        }
      } catch (error) {
        console.log(error);
        this.periodos = [];
        this.periodoSeleccionadoId = null;
        this.periodoSeleccionado = null;
      }
    },

    /**
     * Pre confirmacion indicando con que interval se va a generar la CTS si aplica o no
     * Si hay interes a aplicar se mostrara
     * Si no hay interes aplicable ejecuta generarCts directamente
     */
    async preGenerarCts() {
      try {
        this.addPreloader();

        const { data } = await CtsService.preGenerar({
          periodo: this.periodoSeleccionado.periodo,
          anio: this.periodoSeleccionado.anio,
        });

        return data;
      } catch (error) {
        console.log(error);
        this.$toast({
          component: ToastificationContent,
          position: "top-right",
          props: {
            title: "Error",
            icon: "XCircleIcon",
            variant: "danger",
            text: error?.response?.data || error.message || error,
          },
        });
      } finally {
        this.removePreloader();
      }
    },

    async generarCts() {
      try {
        this.addPreloader();
        const dataCts = await this.preGenerarCts();

        if (dataCts.aplica_interes) {
          const mensajeInteresHTML = `
            <div style="text-align:left;">
              <p>Se detectó que tu depósito de CTS correspondiente al periodo <b>${
                dataCts.periodo
              } ${dataCts.anio}</b> debía realizarse el <b>${
            dataCts.fecha_pago
          }</b>.</p>
              <p>Actualmente presenta <b>${
                dataCts.dias_atraso
              } días de atraso</b>, por lo que <b>${
            dataCts.aplica_interes ? "sí corresponde" : "no corresponde"
          }</b> aplicar interés legal laboral.</p>
              <p>El cálculo se realizará utilizando el <b>factor diario ${
                dataCts.factor_diario
              }</b>.</p>
            </div>
          `;

          const { isConfirmed } = await this.showConfirmSwal(
            "Cálculo de interés CTS", // title
            mensajeInteresHTML, // text (HTML permitido por Swal)
            {
              html: mensajeInteresHTML, // ← IMPORTANTE: usar html en vez de text
              confirmButtonText: "Calcular interés",
              cancelButtonText: "Volver",
              customClass: {
                confirmButton: "btn btn-outline-success mr-1",
                cancelButton: "btn btn-outline-secondary",
              },
            },
          );

          if (!isConfirmed) {
            return;
          }
        }

        const { data } = await CtsService.generar({
          periodo: this.periodoSeleccionado.periodo,
          anio: this.periodoSeleccionado.anio,
        });

        this.$toast({
          component: ToastificationContent,
          position: "top-right",
          props: {
            title: data.message,
            icon: "CheckCircleIcon",
            variant: "success",
            text: data.message,
          },
        });

        this.myProvider();
        this.$emit("generated");
      } catch (error) {
        console.log(error);
        this.$toast({
          component: ToastificationContent,
          position: "top-right",
          props: {
            title: "Error",
            icon: "XCircleIcon",
            variant: "danger",
            text: error?.response?.data || error.message || error,
          },
        });
      } finally {
        this.removePreloader();
      }
    },
    async aprobarCts() {
      try {
        this.addPreloader();

        const empleadosSeleccionados = this.items
          .filter((item) => item.selected)
          .map((item) => item.employee_id);

        const { data } = await CtsService.aprobar({
          periodo: this.periodoSeleccionado.periodo,
          anio: this.periodoSeleccionado.anio,
          empleados: empleadosSeleccionados,
        });

        this.$toast({
          component: ToastificationContent,
          position: "top-right",
          props: {
            title: data.message,
            icon: "CheckCircleIcon",
            variant: "success",
            text: data.message,
          },
        });

        this.myProvider();
      } catch (error) {
        console.log(error);
        this.$toast({
          component: ToastificationContent,
          position: "top-right",
          props: {
            title: "Error",
            icon: "XCircleIcon",
            variant: "danger",
            text: error?.response?.data || error.message || error,
          },
        });
      } finally {
        this.removePreloader();
      }
    },

    async handleIconClick(item, tipo_message, categoria) {
      this.errorDataModal = {
        data: item,
        tipo: tipo_message,
        categoria: categoria,
      };
      this.showModalErrors = true;
    },

    abrirRetornosDetalle(item) {
      this.retornosDetalleData = item;
      this.showRetornosDetalleModal = true;
    },

    abrirTramo3Detalle(item) {
      this.tramo3DetalleData = item;
      this.showTramo3DetalleModal = true;
    },

    // async exportToExcel(ctx) {
    //   try {
    //     this.addPreloader();
    //     const params = {
    //       page: ctx.currentPage,
    //       perpage: ctx.perPage,
    //       search_txt: this.filterPrincipal.model,
    //       start_date_from: this.filters[0].model,
    //       start_date_to: this.filters[1].model,
    //       area_id: this.filters[2].model,
    //     };

    //     const response = await VacacionesService.exportToExcel(params);

    //     // Extraer nombre de archivo desde el header Content-Disposition
    //     const disposition = response.headers["content-disposition"];
    //     let filename = "vacaciones.xlsx";
    //     if (disposition && disposition.includes("filename=")) {
    //       filename = disposition
    //         .split("filename=")[1]
    //         .replace(/['"]/g, "") // eliminar comillas si hay
    //         .trim();
    //     }

    //     this.forceFileDownload(response.data, filename);
    //   } catch (error) {
    //     console.log(error);
    //   } finally {
    //     this.removePreloader();
    //   }
    // },
    // async getAreas() {
    //   try {
    //     const { data } = await EmployeeService.getAllAreas({
    //       moduleId: this.currentUser.modul_id,
    //     });
    //     this.filters[2].options = data;
    //   } catch (error) {
    //     console.log(error);
    //   }
    // },
  },
};
</script>
<style>
.table-sticky th {
  vertical-align: middle !important;
  /* centra el texto verticalmente */
  text-align: center !important;
  /* centra horizontalmente */
  z-index: 2 !important;
}

/* Primera fila sticky (encabezados principales) */
.table-sticky th.sticky-top {
  position: sticky !important;
  top: 0 !important;
  z-index: 3 !important;
}

/* Segunda fila sticky (subcolumnas de Inasistencias) */
.table-sticky th.sticky-sub {
  position: sticky !important;
  top: 26.165px !important;
  /* Ajusta este valor según la altura de la primera fila */
  z-index: 2 !important;
}

.sticky-data {
  position: sticky;
  bottom: 0;
  z-index: 1000;
}

/* Columna Trabajador fija / sticky */
.sticky-col {
  position: sticky !important;
  left: 0 !important;
}

.table-sticky th.sticky-col,
.table-sticky thead th.sticky-col,
th.sticky-col {
  position: sticky !important;
  top: 0 !important;
  left: 0 !important;
  z-index: 50 !important;
  background-color: #f3f2f7 !important;
  text-align: left !important;
  box-shadow: 2px 0 4px -2px rgba(0, 0, 0, 0.15);
}

.table-sticky td.sticky-col,
.table-sticky tbody td.sticky-col,
td.sticky-col {
  position: sticky !important;
  left: 0 !important;
  z-index: 2 !important;
  background-color: #ffffff !important;
  text-align: left !important;
  box-shadow: 2px 0 4px -2px rgba(0, 0, 0, 0.15);
}

tr:hover > td.sticky-col {
  background-color: #f8f8f8 !important;
}

/* Modo oscuro */
.dark-layout .table-sticky th.sticky-col,
.dark-layout th.sticky-col {
  background-color: #343d55 !important;
  box-shadow: 2px 0 4px -2px rgba(0, 0, 0, 0.4);
}

.dark-layout .table-sticky td.sticky-col,
.dark-layout td.sticky-col {
  background-color: #283046 !important;
  box-shadow: 2px 0 4px -2px rgba(0, 0, 0, 0.4);
}

.dark-layout tr:hover > td.sticky-col {
  background-color: #3b4561 !important;
}

/* ========================================================== */
/* Columnas destacadas: TOTAL SERVICIOS y BONO TOTAL NETO    */
/* Tonalidad: Guinda / Rojo Pastel elegante                   */
/* ========================================================== */
th.col-destacada-guinda {
  background-color: #fce8ec !important;
  color: #72122c !important;
  border-left: 1px solid #f3ccd5 !important;
  border-right: 1px solid #f3ccd5 !important;
}

td.col-destacada-guinda {
  background-color: #fdf2f4 !important;
  color: #72122c !important;
  border-left: 1px solid #f6d8df !important;
  border-right: 1px solid #f6d8df !important;
}

td.col-destacada-guinda span {
  color: #72122c !important;
}

tr:hover > td.col-destacada-guinda {
  background-color: #fae1e6 !important;
}

/* Modo oscuro para columnas destacadas */
.dark-layout th.col-destacada-guinda {
  background-color: #4a1d27 !important;
  color: #fecdd3 !important;
  border-color: #5c2432 !important;
}

.dark-layout td.col-destacada-guinda {
  background-color: #3b171f !important;
  color: #fecdd3 !important;
  border-color: #5c2432 !important;
}

.dark-layout td.col-destacada-guinda span {
  color: #fecdd3 !important;
}

.dark-layout tr:hover > td.col-destacada-guinda {
  background-color: #4d1e29 !important;
}
</style>
